import { PAGE_MARGIN_L, SPACING_XS_S } from '@audi/audi-ui-design-tokens';
import { Text } from '@oneaudi/unified-web-alpha-components';

import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const TotalPriceSection = styled.div`
	flex-direction: row;
	flex-wrap: wrap;
	display: flex;
	gap: 0px ${SPACING_XS_S}px;
	align-items: center;
`;

export const PriceBarTotalPrice = styled.div``;

// @ts-ignore
export const TotalPricePrefix = styled(Text).attrs(() => ({
	tag: 'p',
	variant: { type: 'copy', order: '2', style: 'normal' },
	className: 'calculation-info-item',
}))``;

// @ts-ignore
export const TotalPrice = styled(Text).attrs(() => ({
	tag: 'p',
	variant: { type: 'copy', order: '1', style: 'bold' },
	className: 'calculation-info-item',
}))`
	color: ${(props) => props.theme.sys.color.text.headline.default};
`;

export const MonthlyPrice = styled(TotalPrice)`
	position: relative;
	color: ${(props) => props.theme.sys.color.text.headline.default};
`;

export const CalculationInfoStyle = styled.div<{ $view?: string }>`
	display: flex;
	align-items: ${({ $view }) => ($view === 'summary' ? 'end' : 'center')};
	justify-content: space-between;
	gap: ${({ $view }) => ($view === 'summary' ? '24px' : 'none')};

	${breakPoints({
		'768': `
		gap: none;
				justify-content: unset;
			`,
	})}
	.small-icon {
		width: 24px;
		min-width: 24px;
		height: 24px;
		min-height: 24px;
		padding: 0;
	}

	.text-grey {
		width: 100%;

		${breakPoints({
			'768': `
			width: max-content;
				flex-direction: column;
				justify-content: unset;
			`,
		})}
	}

	.calculation-info {
		display: flex;
		flex-direction: column;
		margin-right: ${PAGE_MARGIN_L}px;
		height: 55px;
		flex-grow: 0;
		flex-shrink: 0;
		width: auto;
	}

	.calculation-info.total-price {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.calculation-info.total-price,
	.calculation-info.monthly-price {
		margin-right: 0;
		height: auto;
		justify-content: center;
		margin-top: auto;
		flex: 0 1 auto;

		${breakPoints({
			'768': `margin-right: 32px;`,
			'1024': `width: max-content;`,
		})}
	}

	.footer-show-price-container {
		justify-content: space-between !important;
		flex-direction: row !important;
		margin-bottom: 12px;
	}

	.calculation-info-item.loading {
		margin-right: 36px;
		align-self: center;
		margin-bottom: 12px;
		${breakPoints({
			'768': `
				margin-bottom: 0;
			`,
		})}
	}

	.calculation-info-item.more-link {
		position: relative;
		top: -16px;

		span {
			color: white;
		}

		${breakPoints({
			'768': `
				top: -8px;
			`,
		})}
		.icon__container.forward-small {
			transition:
				all 400ms ease-in-out,
				color 0s;
		}
	}

	.calculation-info-item.more-link:hover {
		.icon__container.forward-small {
			margin-left: 5px;
		}
	}

	.item-link {
		display: inline-block;
		margin-top: 6px;
	}

	.item-link-icon {
		position: relative;
		top: 6px;

		* {
			font-size: 18px;
		}
	}

	.calculation-info.monthly-price {
		display: flex;
	}

	.footnote-reference {
		position: absolute;
		top: -0.2em;
	}

	${breakPoints({
		'1024': `margin-right: 8px;`,
	})}
`;

export const Webcalc = styled.div`
	.bron-html,
	.c-compare-and-select,
	.c-tabs__nav {
		background: none !important;
		background-color: unset !important;
	}
`;
